import { routerOutlet } from "@modules/router-outlet";

// router config
import { routes } from './router.config';

export const RouterOutlet = routerOutlet(routes);